import React from 'react';
import PropTypes from 'prop-types';

import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils';
import {Box, Flex, Image, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

import {HotspotContentArrowIcon} from '@amblique/king-living/app/components/icons';

/**
 * HotspotContent component displays author information with image, name, title and arrow
 * @param {Object} props
 * @param {string} props.authorName - The author's name
 * @param {string} props.authorTitle - The author's title/role
 * @param {string} props.authorImage - Path to author image (relative to static/img)
 * @param {Function} props.onClick - Click handler function
 * @param {Object} props.position - Position object with left/top values for absolute positioning
 */
const HotspotContent = ({
  authorName = 'Seymore',
  authorTitle = 'Chair',
  authorImage = 'author-seymore.png',
  onClick,
  ...props
}) => {
  const styles = useMultiStyleConfig('HotspotContent', {});

  return (
    <Flex {...styles.container} onClick={onClick} {...props}>
      <Image
        {...styles.authorImage}
        alt={authorName}
        src={getAssetUrl(`static/img/${authorImage}`)}
      />

      <Box {...styles.authorInfo}>
        <Text {...styles.authorName}>
          {authorName}
        </Text>
        <Text {...styles.authorTitle}>
          {authorTitle}
        </Text>
      </Box>

      <Box {...styles.arrowIcon}>
        <HotspotContentArrowIcon />
      </Box>
    </Flex>
  );
};

HotspotContent.propTypes = {
  authorName: PropTypes.string,
  authorTitle: PropTypes.string,
  authorImage: PropTypes.string,
  onClick: PropTypes.func,
};

export default HotspotContent;
